import type { SubjectViewState } from 'owa-calendar-compose-types';
import { action } from 'satcheljs/lib/legacy';

export default action('updateSubjectSelectionRange')(function updateSubjectSelectionRange(
    viewState: SubjectViewState,
    start: number,
    end: number
) {
    viewState.selectionStart = start;
    viewState.selectionEnd = end;
});
